import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

// Async thunks for blood analysis diseases
export const getBloodAnalysisDiseasesAll = createAsyncThunk(
  "bloodAnalysisDiseaseSchema/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const page = {
        page: 0,
        size: 1000,
      };
      const response = await ApiClient.get(
        "/api/dog/testna_postaja/krvnaAnaliza/bolezen/page",
        undefined,
        page,
        undefined,
        undefined
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const initialState = {
  krvnaAnalizaBolezenVoList: [],
  error: null,
  isLoading: false,
};

const bloodAnalysisDiseaseSchemaSlice = createSlice({
  name: "bloodAnalysisDiseaseSchema",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBloodAnalysisDiseasesAll.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getBloodAnalysisDiseasesAll.fulfilled, (state, action) => {
        state.isLoading = false;
        state.krvnaAnalizaBolezenVoList = action.payload?.content;
      })
      .addCase(getBloodAnalysisDiseasesAll.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = bloodAnalysisDiseaseSchemaSlice.actions;
export default bloodAnalysisDiseaseSchemaSlice.reducer;
